import { defaultLocale } from "../../constants/defaultValues";
import { platform } from "../../functions/utils";
import {
  CHANGE_LOCALE,
  FETCH_EMPLOYEE_SUCCESS,
  CHANGE_FONTSIZE,
  FETCH_BLOCKEDNUMBERS_SUCCESS,
  FETCH_VOICEMAILDESTINATION_SUCCESS,
  FETCH_AUDITLOGS_SUCCESS,
  FETCH_PAYMENTINFO_SUCCESS,
  FETCH_SETTING_ERROR,
  FETCH_SETTING_LOADING,
  FETCH_AI_SETTINGS_SUCCESS,
  FETCH_AI_SETTINGS_LOADING,
  FETCH_AI_SETTINGS_ERROR,
  UPDATE_AI_SETTINGS_SUCCESS,
  UPDATE_GOOGLE_CALENDAR_NAME,
  DELETE_GOOGLE_CALENDAR,
  FETCH_GOOGLE_CALENDARS_LOADING,
  FETCH_GOOGLE_CALENDARS_SUCCESS,
  FETCH_GOOGLE_CALENDARS_ERROR,
} from "../action/index";

const INIT_STATE = {
  locale: defaultLocale,
  is_loading: true,
  employees_data: [],
  blocked_numbers: [],
  voicemail_destinations: [],
  audit_logs: [],
  payment_details: {},
  fontsize:
    platform == "mobile"
      ? "medium"
      : localStorage.getItem("userfont") || "medium",
  ai_settings: {
    is_ai_enabled: false,
    business_name: "",
    business_hours: "",
    booking_link: "",
    faq_context: "",
    stop_rules_json: {},
  },
  googleConnections: [],
  calendars: [],
  calendars_loading: false,
  calendars_error: null,
};

const settingsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHANGE_LOCALE:
      return { ...state, locale: action.payload };
    case CHANGE_FONTSIZE:
      return { ...state, fontsize: action.payload };

    case FETCH_EMPLOYEE_SUCCESS:
      return { ...state, employees_data: action.payload, is_loading: false };
    case FETCH_BLOCKEDNUMBERS_SUCCESS:
      return { ...state, blocked_numbers: action.payload, is_loading: false };
    case FETCH_VOICEMAILDESTINATION_SUCCESS:
      return {
        ...state,
        voicemail_destinations: action.payload,
        is_loading: false,
      };
    case FETCH_AUDITLOGS_SUCCESS:
      return { ...state, audit_logs: action.payload, is_loading: false };
    case FETCH_PAYMENTINFO_SUCCESS:
      return {
        ...state,
        payment_details: {
          plan: action.payload.plan,
          paymentsHistory: action.payload.paymentsHistory,
          defaultPaymentMethod: action.payload.defaultPaymentMethod,
          paymentMethods: action.payload.paymentMethods,
          upcomingPayments: action.payload.upcomingPayments,
          subscription_status: action.payload.subscription_status,
          price_id: action.payload.price_id,
          setup_fee: action.payload.setup_fee,
          expiry: action.payload.expiry,
        },
        is_loading: false,
      };

    case FETCH_SETTING_LOADING:
      return { ...state, is_loading: true, error: null };
    case FETCH_SETTING_ERROR:
      return { ...state, is_loading: false, error: "FETCH_SETTING_ERROR" };

    /** AI Assistant */
    case FETCH_AI_SETTINGS_LOADING:
      return { ...state, is_loading: true, error: null };

    case FETCH_AI_SETTINGS_SUCCESS:
      return {
        ...state,
        ai_settings: action.payload,
        is_loading: false,
      };

    case UPDATE_AI_SETTINGS_SUCCESS:
      return {
        ...state,
        ai_settings: action.payload,
        is_loading: false,
      };

    case FETCH_AI_SETTINGS_ERROR:
      return {
        ...state,
        is_loading: false,
        error: "FETCH_AI_SETTINGS_ERROR",
      };

    case FETCH_GOOGLE_CALENDARS_LOADING:
      return {
        ...state,
        calendars_loading: true,
        calendars_error: null,
      };

    case FETCH_GOOGLE_CALENDARS_SUCCESS:
      return {
        ...state,
        googleConnections: action.payload,
        calendars_loading: false,
      };

    case FETCH_GOOGLE_CALENDARS_ERROR:
      return {
        ...state,
        googleConnections: [],
        calendars_loading: false,
        calendars_error: "FETCH_GOOGLE_CAL_ERROR",
      };

    case UPDATE_GOOGLE_CALENDAR_NAME:
      return {
        ...state,
        googleConnections: state.googleConnections.map((conn) => {
          // Not this connection → skip
          if (conn.connectionId !== action.payload.connectionId) return conn;

          return {
            ...conn,
            calendars: conn.calendars.map((cal) =>
              cal.calendarId === action.payload.calendarId
                ? { ...cal, friendly_name: action.payload.friendlyName }
                : cal
            ),
          };
        }),
      };

    case DELETE_GOOGLE_CALENDAR:
      return {
        ...state,
        googleConnections: state.googleConnections.map((conn) => {
          // Not the connection we are deleting a calendar from
          if (conn.connectionId !== action.payload.connectionId) return conn;

          return {
            ...conn,
            calendars: conn.calendars.filter(
              (cal) => cal.calendarId !== action.payload.calendarId
            ),
          };
        }),
      };

    default:
      return { ...state };
  }
};

export default settingsReducer;
